export class AlgoliaApiValidUntilError extends Error {}

export function isValidUntilError(error: Error) {
  return error.message?.includes('validUntil');
}
